import React, { useContext, useEffect, useRef, useState } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../../Services/BackEndAPI'
import { Button, Dialog, Grid, IconButton, Stack, Typography } from '@mui/material'
import { MensagemTipo } from '../../../GlobalStates/MensagemState'
import InputText from '../../../DevComponents/InputText'
import ClsValidacao from '../../../Utils/ClsValidacao'
import { PedidoItemInterface, rsERPEstoqueProdutoInterface, rsERPProdutoInterface } from '../../../ImportBackend/Interfaces/PedidoInterfaces'
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev'
import { EMDESENVOLVIMENTO } from '../../../ImportBackend/Config/emDesenvolvimento'
import PesquisarTabela from '../../../DevComponents/PesquisarTabela'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import ClsFormatacao from '../../../Utils/ClsFormatacao'
import Condicional from '../../../Layout/Condicional'

import ContentPaste from '@mui/icons-material/ContentPaste';

interface PropsInterface {
  idNaturezaOperacao: number
  idUnidadeFaturamento: number
  idCondicaoPagamento: number
  idRepresentante: number
  rsPedidoItens: Array<PedidoItemInterface>
  setRsPedidoItens: React.Dispatch<React.SetStateAction<PedidoItemInterface[]>>
  onTotalizarPedido: (rs: Array<PedidoItemInterface>) => void
  pasteItensCopiados: () => void
  rsClonePedido: number
}

interface PesquisaInterface {
  descricao: string
  idProduto: number
  idUnidadeMedida: number
  descricaoProduto: string
}

enum StatusFormEnum {
  PESQUISANDO = 0,
  INCLUINDO_PRODUTO = 1,
  EDITANDO_PRODUTO = 2,
  EDITANDO_VALOR_UNITARIO = 3
}

enum CampoValorEdicaoAtualEnum {
  INICIAL = 0,
  EDICAO = 1
}

export default function PedidosItem({ idNaturezaOperacao, idUnidadeFaturamento, idCondicaoPagamento, rsPedidoItens, setRsPedidoItens, onTotalizarPedido, pasteItensCopiados, rsClonePedido, idRepresentante }: PropsInterface) {

  const vrCasasDecimais = (valor: number, casasDecimais: number = 2): number => parseFloat(valor.toFixed(casasDecimais))

  const setFocusQuantidade = useRef(true)

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface

  const clsFormatos: ClsFormatacao = new ClsFormatacao()

  const { setMensagemState } = (useContext(ContextoGlobal) as ContextoGlobalInterface)

  const campoValorEdicaoAtual = useRef<CampoValorEdicaoAtualEnum>(CampoValorEdicaoAtualEnum.INICIAL)

  const abortController: AbortController = new AbortController()

  const clsApi = new BackEndAPI()

  const [erros, setErros] = useState({})

  const [rsStatusForm, setRsStatusForm] = useState<StatusFormEnum>(StatusFormEnum.PESQUISANDO)

  const [rsProdutos, setRsProdutos] = useState<Array<rsERPEstoqueProdutoInterface>>([])

  const ResetDados: PedidoItemInterface = {
    idPedidoItem: 0,
    idPedido: 0,
    idEmpresa: 0,
    idCentroEstoque: 0,
    descricaoCentroEstoque: '',
    descricaoProduto: '',
    idProduto: 0,
    tipoDescontoAcrescimoUnitario: true,
    perDescontoUnitario: 0,
    vrDescontoUnitario: 0,
    perAcrescimoUnitario: 0,
    vrAcrescimoUnitario: 0,
    perDesconto: 0,
    vrDesconto: 0,
    perAcrescimo: 0,
    vrAcrescimo: 0,
    vrUnitario: 0,
    saldoEstoque: 0,
    permitirEstoqueNegativo: false,
    vrTotal: 0,
    vrLiquido: 0,
    perComissao: 0,
    quantidade: 0,
    desconto: 0,
    vrSugerido: 0,
    vrMinimo: 0,
    vrMaximo: 0,
    idUnidadeMedida: 0,
    perDescontoTributario: 0,
    vrDescontoTributario: 0,
    valorCusto: 0
  }

  const [rsDados, setRsDados] = useState<PedidoItemInterface>(ResetDados)

  const [rsValorUnitario, setRsValorUnitario] = useState<PedidoItemInterface>(ResetDados)

  const editandoValorUnitario = useRef<boolean>(false)

  const [rsIndiceEdicao, setRsIndiceEdicao] = useState<number>(-1)

  const ResetPesquisa: PesquisaInterface = {
    descricao: '',
    idProduto: 0,
    idUnidadeMedida: 0,
    descricaoProduto: ''
  }

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>(ResetPesquisa)

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Estoque',
      campo: 'DESCRICAO',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Pendente',
      campo: 'QTD_EM_PEDIDO_PENDENTE',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs, 0)
    },
    {
      cabecalho: 'Saldo',
      campo: 'SALDO_QTD',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs, 0)
    },
    {
      cabecalho: 'Valor',
      campo: 'VALOR_UNITARIO',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    }
  ]
  const CabecalhoItens: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Produto',
      campo: 'descricaoProduto',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Estoque',
      campo: 'descricaoCentroEstoque',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Qtd',
      campo: 'quantidade',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr. Unitário',
      campo: 'vrUnitario',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '% Desc. Trib.',
      campo: 'perDescontoTributario',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr. Desc. Trib.',
      campo: 'vrDescontoTributario',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr. Total',
      campo: 'vrTotal',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '% Desc',
      campo: 'perDesconto',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '$ Desc',
      campo: 'vrDesconto',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '% Acréscimo',
      campo: 'perAcrescimo',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '$ Acréscimo',
      campo: 'vrAcrescimo',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr. Líquido',
      campo: 'vrLiquido',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    }
  ]

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio('quantidade', rsDados, erros, retorno)

    if (retorno) {

      if (rsDados.quantidade > rsDados.saldoEstoque && !rsDados.permitirEstoqueNegativo) {
        erros.quantidade = 'Saldo menor que quantidade'
        retorno = false
      }

      if (rsDados.perDesconto > contexto.loginState.perDescontoMaximo) {
        erros.perDesconto = 'Desconto maior que o permitido'
        retorno = false
      }

    }

    setErros(erros)

    return retorno

  }

  const onChangeProduto = (rs: rsERPProdutoInterface) => {

    if (rs && rs.ID_PRODUTO) {

      setPesquisa({ ...pesquisa, idProduto: rs.ID_PRODUTO, idUnidadeMedida: rs.ID_UNIDADE_MEDIDA, descricaoProduto: rs.NOME })

      pesquisarPrecos(rs.ID_PRODUTO)

    }
  }

  const pesquisarPrecos = (idProduto: number) => {

    const query: string = `
      getERPEstoqueProdutoValor (
        idProduto: ${idProduto},
        idUnidadeFaturamento: ${idUnidadeFaturamento},
        idRepresentante: ${idRepresentante},
        idCondicaoPagamento: ${idCondicaoPagamento},
        idNaturezaOperacao: ${idNaturezaOperacao}
      ) {
        ID_PRODUTO
        ID_EMPRESA
        ID_CENTRO_ESTOQUE
        DESCRICAO
        SALDO_QTD
        QTD_EM_PEDIDO_PENDENTE
        PERMITIR_ESTOQUE_NEGATIVO
        VALOR_UNITARIO
        VALOR_SUGERIDO
        PERC_COMISSAO
        VALOR_MINIMO
        VALOR_MAXIMO
        VALOR_CUSTO
        PER_DESCONTO_TRIBUTARIO
      }
    `

    clsApi.query<Array<rsERPEstoqueProdutoInterface>>(query, 'getERPEstoqueProdutoValor', 'Pesquisando Produtos...', contexto, abortController).then((rs) => {

      setRsProdutos(rs)

    }).catch((e) => {

      setMensagemState({
        cb: null,
        exibir: true,
        exibirBotao: true,
        mensagem: 'Erro na Consulta do ERP - '.concat(e),
        tipo: MensagemTipo.Error,
        titulo: 'Erro ERP!'
      })

    })

    return () => {

      abortController.abort()
    }
  }

  const onApagarProduto = (indice: number) => {
    let tmp = [...rsPedidoItens]

    tmp.splice(indice, 1)
    setRsIndiceEdicao(0)

    setRsPedidoItens(tmp)

    onTotalizarPedido(tmp)
  }

  const onAdicionarProduto = (rs: rsERPEstoqueProdutoInterface) => {

    let indice = rsPedidoItens.findIndex(v => v.idProduto === rs.ID_PRODUTO && v.idEmpresa === rs.ID_EMPRESA && v.idCentroEstoque === rs.ID_CENTRO_ESTOQUE)

    // Se produto já existe... Se não, inclui um novo...
    if (indice >= 0) {
      setRsDados(rsPedidoItens[indice])
    } else {

      const tmpDados: PedidoItemInterface = {
        idPedidoItem: 0,
        idPedido: 0,
        idEmpresa: rs.ID_EMPRESA,
        idCentroEstoque: rs.ID_CENTRO_ESTOQUE,
        descricaoCentroEstoque: rs.DESCRICAO,
        descricaoProduto: pesquisa.descricaoProduto,
        idProduto: rs.ID_PRODUTO,
        vrUnitario: rs.VALOR_SUGERIDO,
        saldoEstoque: rs.SALDO_QTD,
        permitirEstoqueNegativo: rs.PERMITIR_ESTOQUE_NEGATIVO,
        vrTotal: 0,
        vrLiquido: 0,
        perComissao: rs.PERC_COMISSAO,
        tipoDescontoAcrescimoUnitario: true,
        perDescontoUnitario: 0,
        vrDescontoUnitario: 0,
        perAcrescimoUnitario: 0,
        vrAcrescimoUnitario: 0,
        perDesconto: 0,
        vrDesconto: 0,
        perAcrescimo: 0,
        vrAcrescimo: 0,
        quantidade: 0,
        desconto: 0,
        vrSugerido: rs.VALOR_SUGERIDO,
        vrMinimo: rs.VALOR_MINIMO,
        vrMaximo: rs.VALOR_MAXIMO,
        idUnidadeMedida: pesquisa.idUnidadeMedida,
        perDescontoTributario: rs.PER_DESCONTO_TRIBUTARIO,
        vrDescontoTributario: vrCasasDecimais((rs.VALOR_SUGERIDO * (1 - rs.PER_DESCONTO_TRIBUTARIO / 100))),
        valorCusto: rs.VALOR_CUSTO
      }

      indice = -1

      setRsDados(tmpDados)

    }

    setRsIndiceEdicao(indice)

    setRsStatusForm(StatusFormEnum.EDITANDO_PRODUTO)

    setFocusQuantidade.current = true

  }

  const btCancelarItem = () => {
    setRsDados(ResetDados)
    setRsStatusForm(StatusFormEnum.PESQUISANDO)
  }

  const btConfirmarItem = () => {
    if (validarDados()) {

      let tmpPedidoItens = [...rsPedidoItens]

      if (rsIndiceEdicao >= 0) {
        tmpPedidoItens[rsIndiceEdicao] = { ...rsDados }
      } else {
        tmpPedidoItens.push({ ...rsDados })
      }

      setRsPedidoItens(tmpPedidoItens)
      onTotalizarPedido(tmpPedidoItens)

      setPesquisa(ResetPesquisa)
      setRsProdutos([])

      setRsStatusForm(StatusFormEnum.PESQUISANDO)

      focarCampo('ID_PRODUTO', 'text')
    }
  }

  const onAlterarPerDesconto = (rs: number) => {

    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {

      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO

      let tmpDados = { ...rsDados }

      let percentual: number = typeof rs === 'number' && tmpDados.quantidade > 0 ? rs : 0

      if (percentual <= contexto.loginState.perDescontoMaximo) {
        tmpDados.perDesconto = percentual
        tmpDados.perDescontoUnitario = percentual
      } else {
        setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: 'Desconto Excede o Limite!',
          tipo: MensagemTipo.Warning,
          titulo: 'Atenção!'
        })
        tmpDados.perDesconto = 0
        tmpDados.perDescontoUnitario = 0
      }

      tmpDados.vrTotal = vrCasasDecimais((tmpDados.vrUnitario * tmpDados.quantidade))
      tmpDados.vrDesconto = vrCasasDecimais((tmpDados.vrTotal * tmpDados.perDesconto / 100))
      tmpDados.vrDescontoUnitario = tmpDados.quantidade > 0 ? vrCasasDecimais((tmpDados.vrDesconto / tmpDados.quantidade)) : 0

      tmpDados.vrAcrescimo = 0
      tmpDados.perAcrescimo = 0
      tmpDados.vrAcrescimoUnitario = 0
      tmpDados.perAcrescimoUnitario = 0

      setRsDados(calcularValorLiquido(tmpDados))

    }

  }

  const calcularValorLiquido = (tmpDados: PedidoItemInterface) => {

    let retorno = { ...tmpDados }

    if (retorno.tipoDescontoAcrescimoUnitario) {
      retorno.vrTotal = vrCasasDecimais(((retorno.vrUnitario - retorno.vrDescontoUnitario + retorno.vrAcrescimoUnitario) * retorno.quantidade))
    } else {
      retorno.vrTotal = vrCasasDecimais((retorno.vrUnitario * retorno.quantidade) * (1 - retorno.perDesconto / 100) * (1 + retorno.perAcrescimo / 100))
    }

    retorno.vrDescontoTributario = vrCasasDecimais((retorno.vrTotal * (1 - retorno.perDescontoTributario / 100)) / retorno.quantidade)
    retorno.vrLiquido = vrCasasDecimais((retorno.vrTotal * (1 - retorno.perDescontoTributario / 100)))

    /*
    console.clear()
    console.log(
      'retorno.tipoDescontoAcrescimoUnitario', retorno.tipoDescontoAcrescimoUnitario,
      'retorno.vrUnitario', retorno.vrUnitario,
      'retorno.vrDescontoUnitario', retorno.vrDescontoUnitario,
      'retorno.vrAcrescimoUnitario', retorno.vrAcrescimoUnitario,
      'retorno.quantidade', retorno.quantidade,
      'retorno.vrDescontoTributario', retorno.vrDescontoTributario,
      'retorno.perDescontoTributario', retorno.perDescontoTributario,
      'retorno.vrTotal', retorno.vrTotal,
    )
      */

    // retorno.vrDescontoTributario = vrCasasDecimais( ( ( retorno.vrUnitario - retorno.vrDescontoUnitario + retorno.vrAcrescimoUnitario ) * ( 1 - retorno.perDescontoTributario / 100 ) ) )


    // retorno.vrLiquido = vrCasasDecimais( ( ( retorno.vrTotal - retorno.vrDesconto + retorno.vrAcrescimo - retorno.vrDescontoTributario ) ) )

    // console.log('PÓS calcularValorLiquido', retorno.vrTotal, retorno.vrUnitario, retorno.vrDesconto)

    return retorno
  }

  const onAlterarValorDesconto = (rs: number) => {

    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {

      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO

      let tmpDados = { ...rsDados }

      // Se for DescontoUnitário, calcula os percentuais e transforma em desconto total
      if (tmpDados.tipoDescontoAcrescimoUnitario) {
        tmpDados.vrDescontoUnitario = rs
        rs = vrCasasDecimais((tmpDados.vrDescontoUnitario * tmpDados.quantidade))
      } else {
        tmpDados.vrDescontoUnitario = vrCasasDecimais((rs / tmpDados.quantidade))
      }

      tmpDados.perDescontoUnitario = vrCasasDecimais((tmpDados.vrDescontoUnitario / tmpDados.vrUnitario * 100))

      tmpDados.vrTotal = vrCasasDecimais((tmpDados.vrUnitario * tmpDados.quantidade))

      let percentual: number = typeof rs === 'number' ? vrCasasDecimais((rs / tmpDados.vrTotal * 100)) : 0

      if (percentual <= contexto.loginState.perDescontoMaximo) {
        tmpDados.perDesconto = percentual
        tmpDados.vrDesconto = rs
      } else {
        setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: 'Desconto Excede o Limite!',
          tipo: MensagemTipo.Warning,
          titulo: 'Atenção!'
        })
        tmpDados.perDesconto = 0
        tmpDados.vrDesconto = 0
        tmpDados.vrDescontoUnitario = 0
        tmpDados.perDescontoUnitario = 0
      }

      tmpDados.vrAcrescimo = 0
      tmpDados.perAcrescimo = 0
      tmpDados.perAcrescimoUnitario = 0
      tmpDados.vrAcrescimoUnitario = 0

      setRsDados(calcularValorLiquido(tmpDados))

    }

  }

  const onAlterarPerAcrescimo = (rs: number) => {

    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {

      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO

      let tmpDados = { ...rsDados }

      let percentual: number = typeof rs === 'number' && tmpDados.quantidade > 0 ? rs : 0

      tmpDados.perAcrescimo = rs
      tmpDados.perAcrescimoUnitario = rs
      tmpDados.vrTotal = vrCasasDecimais((tmpDados.vrUnitario * tmpDados.quantidade))
      tmpDados.vrAcrescimo = vrCasasDecimais((tmpDados.vrTotal * percentual / 100))
      tmpDados.vrAcrescimoUnitario = tmpDados.quantidade > 0 ? vrCasasDecimais((tmpDados.vrAcrescimo / tmpDados.quantidade)) : 0

      tmpDados.vrDesconto = 0
      tmpDados.perDesconto = 0
      tmpDados.vrDescontoUnitario = 0
      tmpDados.perDescontoUnitario = 0

      setRsDados(calcularValorLiquido(tmpDados))

    }

  }

  const onAlterarValorAcrescimo = (rs: number) => {

    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {

      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO

      let tmpDados = { ...rsDados }

      // Se for acréscimo unitário, calcula os percentuais e transforma em acréscimo total
      if (tmpDados.tipoDescontoAcrescimoUnitario) {
        tmpDados.vrAcrescimoUnitario = rs
        rs = vrCasasDecimais((tmpDados.vrAcrescimoUnitario * tmpDados.quantidade))
      } else {
        tmpDados.vrAcrescimoUnitario = vrCasasDecimais((rs / tmpDados.quantidade))
      }

      tmpDados.perAcrescimoUnitario = vrCasasDecimais((tmpDados.vrAcrescimoUnitario / tmpDados.vrUnitario * 100))

      tmpDados.vrTotal = vrCasasDecimais((tmpDados.vrUnitario * tmpDados.quantidade))

      let percentual: number = typeof rs === 'number' ? vrCasasDecimais((rs / tmpDados.vrTotal * 100)) : 0

      tmpDados.perAcrescimo = typeof percentual === "number" ? percentual : tmpDados.perAcrescimoUnitario
      tmpDados.vrAcrescimo = rs

      tmpDados.vrDesconto = 0
      tmpDados.perDesconto = 0
      tmpDados.perDescontoUnitario = 0
      tmpDados.vrDescontoUnitario = 0

      setRsDados(calcularValorLiquido(tmpDados))

    }

  }

  const onAlterarTipoDescontoAcrescimoUnitario = (rs: boolean) => {
    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {
      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO
      setRsDados({ ...rsDados, tipoDescontoAcrescimoUnitario: rs })
    }
  }

  useEffect(() => {
    setRsProdutos([])
  }, [idNaturezaOperacao])

  useEffect(() => {

    campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.INICIAL

  })

  useEffect(() => {

    const txtQuantidade = document.getElementsByName('quantidade')[0]

    if (txtQuantidade && setFocusQuantidade.current) {

      setFocusQuantidade.current = false

      txtQuantidade.focus()

      //@ts-ignore
      txtQuantidade.select()

    } else {
      const txtIdProduto = document.getElementsByName('ID_PRODUTO')[0]

      if (txtIdProduto) {
        txtIdProduto.focus()
      }
    }

  })

  const onAlterarQuantidade = (rs: number) => {

    let quantidade: number = typeof rs === 'number' ? rs : 0

    let tmpDados = { ...rsDados }
    tmpDados.vrTotal = vrCasasDecimais((tmpDados.vrUnitario * quantidade))

    tmpDados.vrAcrescimo = vrCasasDecimais((quantidade * tmpDados.vrAcrescimoUnitario))
    tmpDados.perAcrescimo = vrCasasDecimais((tmpDados.vrAcrescimo / tmpDados.vrTotal * 100))
    tmpDados.perAcrescimoUnitario = tmpDados.perAcrescimo

    tmpDados.vrDesconto = vrCasasDecimais((quantidade * tmpDados.vrDescontoUnitario))
    tmpDados.perDesconto = vrCasasDecimais((tmpDados.vrDesconto / tmpDados.vrTotal * 100))
    tmpDados.perDescontoUnitario = tmpDados.perDesconto

    tmpDados.quantidade = quantidade

    setRsDados(calcularValorLiquido(tmpDados))

  }

  const focarCampo = (campo: string, tipo: 'text' | 'button') => {

    const txtCampo = document.getElementsByName(campo)[0]

    if (txtCampo) {

      txtCampo.focus()
      if (tipo === 'text') {
        //@ts-ignore
        txtCampo.select()
      }
    }

  }

  const onEditarProduto = (indice: number) => {
    setRsDados(rsPedidoItens[indice])
    setRsValorUnitario(rsPedidoItens[indice])
    setRsIndiceEdicao(indice)
    setRsStatusForm(StatusFormEnum.EDITANDO_PRODUTO)
  }

  // Alteração de Valor Unitário do Produto
  const onEditarValorUnitario = (indice: number) => {
    setRsValorUnitario({ ...rsPedidoItens[indice] })
    setRsIndiceEdicao(indice)
    setRsStatusForm(StatusFormEnum.EDITANDO_VALOR_UNITARIO)
  }

  const btCancelarEdicaoValorUnitario = () => {
    setRsStatusForm(StatusFormEnum.PESQUISANDO)
  }

  const onAlterarValorUnitario = (rsValorUnitario: PedidoItemInterface) => {

    let tmpDados: PedidoItemInterface = { ...rsValorUnitario }
    const vrUnitario: number = rsPedidoItens[rsIndiceEdicao].vrUnitario

    tmpDados.vrAcrescimoUnitario = rsValorUnitario.vrUnitario > vrUnitario ? parseFloat((rsValorUnitario.vrUnitario - vrUnitario).toFixed(2)) : 0
    tmpDados.vrDescontoUnitario = rsValorUnitario.vrUnitario < vrUnitario ? parseFloat((vrUnitario - rsValorUnitario.vrUnitario).toFixed(2)) : 0

    tmpDados.vrUnitario = parseFloat(vrUnitario.toFixed(2))

    // Se for Acrescimo
    if (tmpDados.vrAcrescimoUnitario > 0) {

      tmpDados.perAcrescimoUnitario = parseFloat((tmpDados.vrAcrescimoUnitario / tmpDados.vrUnitario * 100).toFixed(2))

      tmpDados.vrTotal = parseFloat((tmpDados.vrUnitario * tmpDados.quantidade).toFixed(2))

      tmpDados.perAcrescimo = tmpDados.perAcrescimoUnitario

      tmpDados.vrAcrescimo = parseFloat((tmpDados.vrAcrescimoUnitario * tmpDados.quantidade).toFixed(2))


      tmpDados.vrDesconto = 0
      tmpDados.perDesconto = 0
      tmpDados.perDescontoUnitario = 0
      tmpDados.vrDescontoUnitario = 0

      tmpDados = calcularValorLiquido(tmpDados)

    }

    // Se for Desconto
    if (tmpDados.vrDescontoUnitario > 0) {

      tmpDados.perDescontoUnitario = parseFloat((tmpDados.vrDescontoUnitario / tmpDados.vrUnitario * 100).toFixed(2))

      tmpDados.vrTotal = parseFloat((tmpDados.vrUnitario * tmpDados.quantidade).toFixed(2))

      tmpDados.perDesconto = tmpDados.perDescontoUnitario

      tmpDados.vrDesconto = parseFloat((tmpDados.vrDescontoUnitario * tmpDados.quantidade).toFixed(2))

      tmpDados.vrAcrescimo = 0
      tmpDados.perAcrescimo = 0
      tmpDados.perAcrescimoUnitario = 0
      tmpDados.vrAcrescimoUnitario = 0

      tmpDados = calcularValorLiquido(tmpDados)

    }

    if (tmpDados.perDesconto <= contexto.loginState.perDescontoMaximo) {

      const tmpPedidoItens: Array<PedidoItemInterface> = JSON.parse(JSON.stringify(rsPedidoItens))
      tmpPedidoItens[rsIndiceEdicao] = tmpDados
      setRsPedidoItens(tmpPedidoItens)
      onTotalizarPedido(tmpPedidoItens)

    } else {

      setMensagemState({
        cb: null,
        exibir: true,
        exibirBotao: true,
        mensagem: 'Desconto Excede o Limite!',
        tipo: MensagemTipo.Warning,
        titulo: 'Atenção!'
      })
      tmpDados.perDesconto = 0
      tmpDados.perDescontoUnitario = 0

    }

    setRsStatusForm(StatusFormEnum.PESQUISANDO)

  }

  return (
    <>

      <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
          <Typography component="h5" variant="h5" align="left">
            Itens do Pedido
            {/*
              <Typography variant="body2" gutterBottom>
              Pesquisa por Código, Auxiliar, Descrição ou Código de Barras.
              </Typography>
              */}
          </Typography>

          <Condicional condicao={rsClonePedido > 0}>
            <IconButton aria-label="delete" color="primary" onClick={() => pasteItensCopiados()}>
              <ContentPaste />
            </IconButton>
          </Condicional>

        </Grid>

        <Condicional condicao={rsStatusForm === StatusFormEnum.PESQUISANDO}>

          <Grid item xs={12}>

            <PesquisarTabela<rsERPProdutoInterface>
              setState={setPesquisa}
              field='ID_PRODUTO'
              fieldSet='idProduto'
              label='Produto'
              dados={pesquisa}
              campoQueryPesquisaID='ID_PRODUTO'
              campoQueryPesquisa='pesquisa'
              camposRetornoQueryPesquisa='{ID_PRODUTO CODIGO_AUXILIAR NOME ATIVO ID_UNIDADE_MEDIDA}'
              campoLabelQueryPesquisa='NOME'
              nomeQueryPesquisa='getERPProduto'
              nomeQueryPesquisaID='getERPProdutoPorId'
              mensagemPesquisa='Procurando Produtos...'
              erros={erros}
              valorAtribuirLimpar={0}
              camposParaExibir={['NOME', 'ID_PRODUTO', 'CODIGO_AUXILIAR']}
              onChange={(rs: rsERPProdutoInterface) => onChangeProduto(rs)}
              inputUpperCase
            />

          </Grid>

          <Grid item xs={12} sx={{ mt: 3 }}>
            <DataTable
              dados={rsProdutos}
              cabecalho={Cabecalho}
              acoes={[
                {
                  icone: 'add',
                  toolTip: '',
                  onAcionador: (rs: rsERPEstoqueProdutoInterface) => onAdicionarProduto(rs),
                  // onDisabled: ( rs ) => ( rs.SALDO_QTD <= 0 && !rs.PERMITIR_ESTOQUE_NEGATIVO ) || rs.VALOR_SUGERIDO <= 0
                  onDisabled: (rs) => (process.env.REACT_APP_ID_EMPRESA_SOMENTE_CONSULTA?.split(",").includes(rs.ID_EMPRESA.toString())) || rs.VALOR_SUGERIDO <= 0
                }
              ]}

            />
          </Grid>

          <Grid item xs={12} sx={{ mt: 3 }}>
            <DataTable
              dados={rsPedidoItens}
              cabecalho={CabecalhoItens}
              acoes={[
                {
                  icone: 'delete',
                  toolTip: 'Apagar Item',
                  onAcionador: (_rs: rsERPEstoqueProdutoInterface, indice) => onApagarProduto(indice),
                  onDisabled: (rs) => rs.SALDO_QTD <= 0
                },
                {
                  icone: 'edit',
                  toolTip: 'Editar Item',
                  onAcionador: (_rs: rsERPEstoqueProdutoInterface, indice) => onEditarProduto(indice),
                  onDisabled: (rs) => rs.SALDO_QTD <= 0
                },
                {
                  icone: 'tune',
                  toolTip: 'Editar Valor Unitário',
                  onAcionador: (_rs: rsERPEstoqueProdutoInterface, indice) => onEditarValorUnitario(indice),
                  onDisabled: (rs) => rs.SALDO_QTD <= 0
                }
              ]}

            />
          </Grid>

        </Condicional>

        <Condicional condicao={rsStatusForm === StatusFormEnum.EDITANDO_VALOR_UNITARIO}>
          <Dialog
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            open={rsStatusForm === StatusFormEnum.EDITANDO_VALOR_UNITARIO}
            onClose={() => btCancelarEdicaoValorUnitario()}
          >
            <Grid container sx={{ padding: 5 }}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  {rsValorUnitario.descricaoProduto}
                </Typography>

                {/*
                <InputText
                dados={rsDados}
                field='descricaoProduto'
                label='Produto'
                disabled={true}
                />
                */}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  {rsValorUnitario.descricaoCentroEstoque}
                </Typography>
                {/*
                <InputText
                  dados={rsDados}
                  field='descricaoCentroEstoque'
                  label='Estoque'
                  disabled={true}
                />
                */}
              </Grid>

              <Grid item xs={12}>
                <InputText
                  dados={rsValorUnitario}
                  field='vrUnitario'
                  label='Valor'
                  tipo='currency'
                  textAlign='right'
                  disabled={!rsDados.tipoDescontoAcrescimoUnitario}
                  setState={setRsValorUnitario}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 2, textAlign: 'right' }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                  <Button variant='contained' onClick={() => btCancelarEdicaoValorUnitario()}>Cancelar</Button>
                  <Button variant='contained' onClick={() => onAlterarValorUnitario(rsValorUnitario)}>Confirmar</Button>
                </Stack>
              </Grid>

            </Grid>

          </Dialog>
        </Condicional>

        <Condicional condicao={rsStatusForm === StatusFormEnum.EDITANDO_PRODUTO}>

          <Dialog
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            open={rsStatusForm === StatusFormEnum.EDITANDO_PRODUTO}
            onClose={() => btCancelarItem()}
          >

            <Grid container sx={{ padding: 5 }}>

              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  {rsDados.descricaoProduto}
                </Typography>

                {/*
                <InputText
                dados={rsDados}
                field='descricaoProduto'
                label='Produto'
                disabled={true}
                />
                */}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  {rsDados.descricaoCentroEstoque}
                </Typography>
                {/*
                <InputText
                  dados={rsDados}
                  field='descricaoCentroEstoque'
                  label='Estoque'
                  disabled={true}
                />
                */}
              </Grid>

              <Grid item xs={12}>
                <InputText
                  dados={rsDados}
                  field='vrUnitario'
                  label='Valor'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6} sx={{ pr: 1 }}>
                <InputText
                  dados={rsDados}
                  field='saldoEstoque'
                  label='Saldo'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6}>
                <InputText
                  dados={rsDados}
                  field='quantidade'
                  label='Quantidade'
                  tipo='currency'
                  textAlign='right'
                  erros={erros}
                  onChange={(rs: number) => onAlterarQuantidade(rs)}
                  mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('btConfirmarItem', 'button') }]}
                />
              </Grid>

              <Grid item xs={6} >
                <InputText
                  dados={rsDados}
                  field='vrTotal'
                  label='Valor Total'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6} sx={{ pl: 1, mt: 3.5, textAlign: 'right', alignContent: 'end', justifyContent: 'flex-end' }}>
                <InputText
                  dados={rsDados}
                  field='tipoDescontoAcrescimoUnitario'
                  label='Aplciar D/A Unitário'
                  tipo='checkbox'
                  textAlign='right'
                  onChange={(rs) => onAlterarTipoDescontoAcrescimoUnitario(rs)}
                />
              </Grid>

              <Condicional condicao={rsDados.tipoDescontoAcrescimoUnitario}>

                <Grid item xs={6} >
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='perDescontoUnitario'
                    label='% Desconto'
                    tipo='currency'
                    textAlign='right'
                    onChange={(rs: number) => onAlterarPerDesconto(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('vrDescontoUnitario', 'text') }]}
                    erros={erros}
                  />
                </Grid>

                <Grid item xs={6} sx={{ pl: 1 }}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='vrDescontoUnitario'
                    label='$ Desconto'
                    tipo='currency'
                    textAlign='right'
                    onChange={(rs: number) => onAlterarValorDesconto(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('perAcrescimoUnitario', 'text') }]}
                    erros={erros}
                  />
                </Grid>

                <Grid item xs={6} sx={{ pr: 1 }}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='perAcrescimoUnitario'
                    label='% Acréscimo'
                    tipo='currency'
                    textAlign='right'
                    setState={setRsDados}
                    erros={erros}
                    onChange={(rs: number) => onAlterarPerAcrescimo(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('vrAcrescimoUnitario', 'text') }]}
                  />
                </Grid>

                <Grid item xs={6}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='vrAcrescimoUnitario'
                    label='$ Acréscimo'
                    tipo='currency'
                    textAlign='right'
                    setState={setRsDados}
                    erros={erros}
                    onChange={(rs: number) => onAlterarValorAcrescimo(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('btConfirmarItem', 'button') }]}
                  />
                </Grid>

              </Condicional>

              <Condicional condicao={!rsDados.tipoDescontoAcrescimoUnitario}>

                <Grid item xs={6} >
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='perDesconto'
                    label='% Desconto'
                    tipo='currency'
                    textAlign='right'
                    onChange={(rs: number) => onAlterarPerDesconto(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('vrDesconto', 'text') }]}
                    erros={erros}
                  />
                </Grid>

                <Grid item xs={6} sx={{ pl: 1 }}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='vrDesconto'
                    label='$ Desconto'
                    tipo='currency'
                    textAlign='right'
                    onChange={(rs: number) => onAlterarValorDesconto(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('perAcrescimo', 'text') }]}
                    erros={erros}
                  />
                </Grid>

                <Grid item xs={6} sx={{ pr: 1 }}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='perAcrescimo'
                    label='% Acréscimo'
                    tipo='currency'
                    textAlign='right'
                    setState={setRsDados}
                    erros={erros}
                    onChange={(rs: number) => onAlterarPerAcrescimo(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('vrAcrescimo', 'text') }]}
                  />
                </Grid>

                <Grid item xs={6}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='vrAcrescimo'
                    label='$ Acréscimo'
                    tipo='currency'
                    textAlign='right'
                    setState={setRsDados}
                    erros={erros}
                    onChange={(rs: number) => onAlterarValorAcrescimo(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('quantidade', 'text') }]}
                  />
                </Grid>

              </Condicional>

              <Grid item xs={6} sx={{ pr: 1 }}>
                <InputText
                  dados={rsDados}
                  field='perDescontoTributario'
                  label='% Desc. Tributário'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6}>
                <InputText
                  dados={rsDados}
                  field='vrDescontoTributario'
                  label='Vr Desc. Tributário'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={12}>
                <InputText
                  dados={rsDados}
                  field='vrLiquido'
                  label='Valor Líquido'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 2, textAlign: 'right' }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                  <Button variant='contained' onClick={() => btCancelarItem()}>Cancelar</Button>
                  <Button variant='contained' name='btConfirmarItem' onClick={() => btConfirmarItem()}>Confirmar</Button>
                </Stack>
              </Grid>

            </Grid>

            <ExibirJSONDev exibir={EMDESENVOLVIMENTO}
              oque={['Dadoos', rsDados]} />

          </Dialog>

        </Condicional>

      </Grid >

      <ExibirJSONDev exibir={EMDESENVOLVIMENTO}
        oque={['Dadoos', rsDados]} />

    </>
  )

}